import React, { useContext } from 'react';
import { AppContext, DispatchContext } from '../AppContext';
import * as actions from '../actions/actions';
import { makeStyles } from '@material-ui/styles';
import { Link, Typography } from '@material-ui/core';
import { config } from '../helpers/constants';
import madeInGermany from '../assets/made-in-germany-logo.png';



export default function PlagAwareLogo(props) {

    const useStyles = makeStyles(theme => ({
        root: {
            position: "absolute",
            bottom: "8px",
            display: "flex",
            justifyContent: "center"
        },
    }));

    const dispatch = useContext(DispatchContext);
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles();

    const color = "#aaaaaa";
    const spacing = 4;

    return (
        <div className={classes.root}>
            <Link href={config.backendUrl + s.copyright.dataProtectionUrl} variant="body2" style={{margin: spacing, color: color}}>{s.copyright.dataProtectionPolicy}</Link>
            <Typography variant="body2" style={{margin: spacing, color: color}}>|</Typography> 
            <Link href={config.backendUrl + s.copyright.imprintUrl} variant="body2" style={{margin: spacing, color: color}}>{s.copyright.imprint}</Link>
            <Typography variant="body2" style={{margin: spacing, color: color}}>|</Typography> 
            <Link href={config.backendUrl + s.copyright.termsOfUseUrl} variant="body2" style={{margin: spacing, color: color}}>{s.copyright.termsOfUse}</Link>
            <Typography variant="body2" style={{margin: spacing, color: color}}>|</Typography>
            <Link
                component="button"
                variant="body2"
                style={{margin: spacing, color: '#1565C0', fontWeight: 'bold'}}
                onClick={() => {
                    dispatch(actions.navigate_to('/revoke'));
                }}
            >{s.copyright.revokeContract}</Link>
            <Typography variant="body2" style={{margin: spacing, color: color}}>|</Typography> 
            <Typography variant="body2" style={{margin: spacing, color: color}}>{s.copyright.copyright}</Typography> 
            <Typography variant="body2" style={{margin: spacing, color: color}}>|</Typography> 
            <img style={{width: 100, height: 16, position: "relative", top: 6, marginLeft: 8}} src={madeInGermany} alt="logo" />
        </div>
    );
}
